import React from "react";
import { Image } from "@themesberg/react-bootstrap";

import ReactLogo from "../assets/img/technologies/react-logo-transparent.svg";
import Loader from "../assets/img/technologies/loader.png";
import Loading from "../assets/img/technologies/Loading.png";
import Loader1 from "../assets/img/technologies/loader-custom.svg";

export default (props) => {
  const { show } = props;

  return (
    <div className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
        {/* loader image  */}
      <Image className="loader-element animate__animated animate__jackInTheBox" src={Loader} height={40} />
    </div>
  );
};
